export default {
  init() {
    // JavaScript to be fired on the page
  },
  finalize() {

    // Countdown timer for 10 minutes from page load
    // var initNow = new Date().getTime();
    // var countDownDate = new Date(initNow + 600000).getTime();
    // var x = setInterval(function() {
    //   var now = new Date().getTime();
    //   var distance = countDownDate - now;
    //   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    //   var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    //   $('.timer .minutes').text(minutes);
    //   $('.timer .seconds').text(seconds);
    //   if (distance < 0) {
    //     clearInterval(x);
    //     $('.timer .minutes').text('0');
    //     $('.timer .seconds').text('0');
    //   }
    // }, 1000);


    function startTimer(duration) {
      var timer = duration;
      var x = setInterval(function() {
        var minutes = parseInt(timer / 60, 10);
        var seconds = parseInt(timer % 60, 10);

        seconds = seconds < 10 ? '0' + seconds : seconds;

        $('.timer .minutes').text(minutes);
        $('.timer .seconds').text(seconds);

        if (--timer < 0) {
          clearInterval(x);
          $('.timer .minutes').text('0');
          $('.timer .seconds').text('0');
        }
      }, 1000);
    }

    window.onload = function() {
      startTimer(599);

      var reviewCount = parseInt($('.yotpo.bottomLine .text-m').text());
      if(reviewCount < 5) {
        $('.upsell-reviews').hide();
      }
    };

    $('.product-video').click(function() {
      $('.modal.video-modal').addClass('open');
    });

    $('.modal .x, .modal').click(function() {
      $('.modal').removeClass('open');
      var thesrc = $('.modal iframe').attr('src');
      $('.modal iframe').attr('src', '').attr('src', thesrc);
    });

    $('.modal .modal-inner *').click(function(e) {
      e.stopPropagation();
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/upsell.js